/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandCouchdb = createReactComponent("outline", "brand-couchdb", "IconBrandCouchdb", [["path", { "d": "M6 12h12v-2a2 2 0 0 1 2 -2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2a2 2 0 0 1 2 2v2z", "key": "svg-0" }], ["path", { "d": "M6 15h12", "key": "svg-1" }], ["path", { "d": "M6 18h12", "key": "svg-2" }], ["path", { "d": "M21 11v7", "key": "svg-3" }], ["path", { "d": "M3 11v7", "key": "svg-4" }]]);

export { IconBrandCouchdb as default };
//# sourceMappingURL=IconBrandCouchdb.mjs.map
